// Returns current quarter string e.g. "Q2-2026"
export const getCurrentQuarter = () => {
  const now = new Date();
  const q   = Math.ceil((now.getMonth() + 1) / 3);
  const fy  = now.getMonth() >= 3 ? now.getFullYear() + 1 : now.getFullYear();
  return `Q${q}-${fy}`;
};